import { get } from "lodash";
import { bool, func, object } from "prop-types";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { AD_LIMIT } from "../../constants";
import { isAdPosition } from "../utils/story";
import { getQueryParamsForArticleApi } from "../utils/utils";
import AdWrapper from "./atoms/AdWrapper";

export const WithStoryAds = ({ counter = {}, componentToRender, story }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], {}));
  let sectionName = currentPath.split("?")[0].split("/")[1];
  let pageName = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_name_mapping", sectionName], "sections")
  );
  const networkId = useSelector((state) => get(state, ["qt", "config", "ads-config", "network_id"], ""));
  let storyPageAdUnit = `/${networkId}/GULFNEWS/Gulfnews_Article/gulfnews_sections_article/gulfnews_sections_article_`;
  const params = getQueryParamsForArticleApi(currentPath);
  if (params.articleApi) {
    storyPageAdUnit = `/${networkId}/GULFNEWS/Gulfnews_App/gulfnews_newapp_articles/gulfnews_newapp_articles_inarticle`;
  }
  const adsConfig = get(qtState, ["config", "ads-config"], {});

  const storyPageLhsAd = get(adsConfig, ["slots", "story_page_lhs_ad_1"], {});

  const noAds = get(qtState, ["config", "noAds"], false);
  counter.paragraphs++;
  const showAd = counter.ads < AD_LIMIT ? isAdPosition(counter) : false;
  if (showAd) {
    counter.ads++;
  }
  const adRef = useRef(null);
  let storyIndex;
  if (adRef.current) {
    const closestInfiniteScrollParent = adRef.current.closest("[data-infinite-scroll]");
    storyIndex = get(closestInfiniteScrollParent, ["dataset", "infiniteScroll"], 0);
  }
  return (
    <div ref={adRef}>
      {componentToRender}
      {showAd && !noAds && storyIndex >= 0 && (
        <AdWrapper
          adStyleName="story-page-ad-slot"
          id={`div-gulfnews_sections_article_${parseInt(storyIndex) + 1}_${counter.ads}`}
          path={`${storyPageAdUnit}${counter.ads}`}
          size={storyPageLhsAd.sizes}
          viewPortSizeMapping={storyPageLhsAd.view_port_size_mapping}
          isLhsAd={true}
          count={counter.ads}
        />
      )}
    </div>
  );
};

WithStoryAds.propTypes = {
  counter: object,
  story: object,
  showAd: bool,
  isParagraph: bool,
  componentToRender: func,
};
